import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSmsChannel } from 'services/smsConversations';
import {
  ICreateSmsChannelPayload,
  ICreateSmsChannelResponse,
} from 'services/smsConversations/types';

interface IProps {
  crmId: number;
  payload: ICreateSmsChannelPayload;
}

export const ThunkCreateSmsChannel = createAsyncThunk<ICreateSmsChannelResponse, IProps>(
  'pod/checkIfTicketHasSmsChannel',
  async ({ crmId, payload }) => {
    const r = await createSmsChannel(crmId, payload);
    return r.data;
  },
);
